"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteAccountRelation = exports.postAccountRelation = exports.putAccountOrganization = exports.putAccountAccessibility = exports.deleteAccountPermission = exports.postAccountPermission = exports.delAccount = exports.postAccount = exports.putAccount = exports.getAccount = exports.getAccounts = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var path = root_1.accountingAuthorized + '/accounts/';

var getAccounts = function getAccounts(authentication, queryParameters) {
  return common_1.get(authentication, path, queryParameters);
};

exports.getAccounts = getAccounts;

var getAccount = function getAccount(authentication, id) {
  return common_1.get(authentication, path + id);
};

exports.getAccount = getAccount;

var putAccount = function putAccount(authentication, record) {
  return common_1.put(authentication, path + record.id, record);
};

exports.putAccount = putAccount;

var postAccount = function postAccount(authentication, record) {
  return common_1.post(authentication, path, record);
};

exports.postAccount = postAccount;

var delAccount = function delAccount(authentication, id) {
  return common_1.del(authentication, path + id);
};

exports.delAccount = delAccount;

var postAccountPermission = function postAccountPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, path, id, permission);
};

exports.postAccountPermission = postAccountPermission;

var deleteAccountPermission = function deleteAccountPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, path, id, permissionId);
};

exports.deleteAccountPermission = deleteAccountPermission;

var putAccountAccessibility = function putAccountAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, path, id, accessibility);
};

exports.putAccountAccessibility = putAccountAccessibility;

var putAccountOrganization = function putAccountOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, path, id, organizationId);
};

exports.putAccountOrganization = putAccountOrganization;

var postAccountRelation = function postAccountRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, path, id, relation);
};

exports.postAccountRelation = postAccountRelation;

var deleteAccountRelation = function deleteAccountRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, path, id, relationId);
};

exports.deleteAccountRelation = deleteAccountRelation;